<template>
  <component
    :is="'script'"
    ref="script"
    async
    :data-gtins="gtins"
    :data-lang="language"
    :data-outtrabrand_id="brandId"
  />
</template>

<script lang="ts" setup>
defineProps<{
  gtins: string
}>()

const language = useCurrentLanguage()
const script = ref<HTMLScriptElement | null>(null)
const brandId = '106'

onMounted(() => {
  if (!script.value) {
    return
  }
  script.value.src = 'https://brandwidgets.outtra.com/js/exped/button-widget.js'
})

onBeforeUnmount(() => {
  if (script.value) {
    script.value.remove()
  }
  document.querySelector('#outtra-base-container')?.remove()
})
</script>

<style lang="postcss">
#outtra-base-container {
  .outtra-modal-trigger-button {
    @apply hover:opacity-60 transition-opacity;
  }

  .outtra-modal-trigger-button img {
    @apply w-auto;
  }
}
</style>
